import  *  as React from "react"
import {FunctionComponent} from "react"
import {classNames} from "../../../Support/classNames"
import { Link } from "react-router-dom";

export const Sidebar: FunctionComponent = () => {
    return(
            <ul className="list-group mb-3 d-none d-lg-flex">
                <li
                    className={classNames('list-group-item', {
                        active: window.location.pathname === '/crews',
                    })}
                >
                    <Link to={'/crews'}>Overview</Link>
                </li>
                <li
                    className={classNames('list-group-item', {
                        active: window.location.pathname === '/crews' + '/calendar',
                    })}
                >
                    <Link to={'/crews' + '/calendar'}>Calendar</Link>
                </li>
            </ul>
    );
};